<template>
  <v-layout row wrap align-content-space-between fill-height>
    <v-flex v-if="loading" class="text-xs-center">
      <v-progress-circular
      indeterminate
      color="primary"
      ></v-progress-circular>
    </v-flex>
    <v-flex v-if="workout && !loading">
      <v-dialog v-model="weightHint" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Weight Measurement!</v-card-title>
          <v-card-text>Currently your lifts are measured in <strong class="primary--text">{{measurements.weight}}</strong>. You can change this to be either pounds or kilos via the settings page.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="" flat @click="closeHint">close</v-btn>
            <v-btn color="primary" flat @click="gotTo">Go To Settings</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="LoadingDialog"
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-if="workoutLogs"
        v-model="lastLogDialog"
        width="500"
      >
        <v-btn
          block
          outline
          slot="activator"
          color="secondary"
        >
          view previous lifts
        </v-btn>
        <v-card flat>
          <v-card-title primary-title>
          <div>
            <h6 class="subheading mb-0">Last logged: {{workoutLogs.created_at | calendarNoTime}}</h6>
          </div>
        </v-card-title>
          <v-card-text>
            <div class="table" :key="objIndex" v-for="(object, objIndex) in workoutLogs" v-if="objIndex.startsWith('wo') && objIndex !== 'workout_id'">
              <h4 class="primary--text">{{object.exercise_name}}</h4>
              <div class="table-header">
                <div>{{ object.set1 | displayWeight | weight }}</div>
                <div>{{ object.set2 | displayWeight | weight }}</div>
                <div>{{ object.set3 | displayWeight | weight }}</div>
                <div>{{ object.set4 | displayWeight | weight }}</div>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="lastLogDialog = false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-expansion-panel class="elevation-0">
        <v-expansion-panel-content>
           <template v-slot:actions>
            <v-icon color="primary">info</v-icon>
          </template>
          <div v-if="workout.title" slot="header">{{workout.title | uppercase}} (click for extra info)</div>
          <v-card>
            <v-card-text v-if="workout.info.length > 0" v-html="workout.info"></v-card-text>
            <v-card-text v-else >NO ADDITIONAL INFO</v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
    <v-flex v-if="exercises.length > 0 && !loading">
      <p class="paddingX mb0" >WHEN YOUR READY TO START CLICK ON THE FIRST EXERCISE</p>
      <v-subheader>Start</v-subheader>
      <ul id="workout-list" v-if="exercises.length > 0" >
        <li  @click="openSheet(index)" v-ripple v-for="(exercise, index) in exercises" :key="index">
          <div class="list-timeline">
            <v-icon color="primary" size="12px">{{radioIcon(exercise)}}</v-icon>
          </div>
          <div class="list-content">
            <div class="list-title">{{exercise.exerciseData.name}} <span class="sub-info secondary--text">{{exercise.sets}}x{{exercise.reps}}</span></div>
          </div>
          <div class="list-action">
            <v-icon color="secondary" v-if="exercise.complete">done</v-icon>
            <v-icon v-else>check_box_outline_blank</v-icon>
          </div>
        </li>
      </ul>
      <v-subheader>End</v-subheader>
      <v-subheader>EOW Drill</v-subheader>
      <p class="paddingX " >DO EACH MOVEMENT ONE AFTER THE OTHER THEN REST FOR THE TIME SHOWN AFTER THE LAST MOVEMENT. REPEAT FOR THE AMOUNT OF REPS SPECIFIED NEXT TO EACH MOVEMENT</p>
      <ul id="workout-list" v-if="movements.length > 0" >
        <li v-for="(exercise, index) in movements" :key="index">
          <!-- <div class="list-timeline">
            <v-icon color="primary" size="12px">{{radioIcon(exercise)}}</v-icon>
          </div> -->
          <span>{{exercise.reps}}</span>
          <div class="list-content">
            <div class="list-title">{{exercise.exerciseData.name}} <span class="sub-info secondary--text">{{exercise.sets}}x<span v-if="exercise.reps">{{exercise.reps}} (reps)</span><span v-if="exercise.time">{{exercise.time}}(secs)</span><span v-if="exercise.rest"> &nbsp Rest: {{exercise.rest}}(secs)</span></span></div>
          </div>
          <div class="list-action">
            <v-btn flat icon @click="openInfoDialog(index)">
              <v-icon color="grey lighten-1">info</v-icon>
            </v-btn>
          </div>
        </li>
      </ul>
    </v-flex>
    <v-flex v-if="exercises.length > 0 && !loading">
      <v-btn
        :disabled="exercises.length !== workoutLog.length" :loading="loadingBtn"
        @click="submitWorkout()" block color="primary">
        Submit
        <v-icon right dark>send</v-icon>
      </v-btn>
    </v-flex>

    <v-bottom-sheet v-model="sheet">
      <v-card v-if="activeData" class="gradient-up" dark>
        <v-btn
          color="white"
          light
          small
          absolute
          top
          fab
          style="left: 50%"
          @click="sheetExtended = !sheetExtended"
        >
          <v-icon style="height: auto">{{fabIcon}}</v-icon>
        </v-btn>
        <v-container grid-list-lg>
          <v-layout v-show="sheetExtended" row wrap>
            <v-flex xs12>
              <p style="padding: 0 16px">
                <span class="subheading">Type: {{activeData.exerciseData.type}}</span><br>
                <span class="subheading">Rest: {{activeData.rest}}</span><br>
                <span class="subheading">Tempo: {{activeData.tempo}}</span>
              </p>
              <div class="video-container">
                <div v-html="activeData.exerciseData.video"></div>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-card-title primary-title>
                <div class="headline">{{activeData.exerciseData.name | uppercase}} | <span class="sub-info white--text">{{activeData.sets}}x{{activeData.reps}}(reps)</span></div>
              </v-card-title>
            </v-flex>
          </v-layout>
          <v-form ref="form">
            <v-layout id="input-layout" row wrap align-center justify-space-between>
              <!-- <input name="workout_id" type="hidden" v-model="form.workout_id">
              <input name="exercise_id" type="hidden" v-model="form.exercise_id"> -->
              <v-flex  class="text-xs-center">
                <input :placeholder="measurements.weight" :class="{'invalid': errors.first('set1')}" name="set1" class="round-input" type="number" maxlength="5" v-model.number="set1">
                <p>Set 1</p>
              </v-flex>
              <v-flex  class="text-xs-center">
                <input :placeholder="measurements.weight" :class="{'invalid': errors.first('set2')}" class="round-input" name="set2" type="number" maxlength="5" v-model.number="set2">
                <p>Set 2</p>
              </v-flex>
              <v-flex  class="text-xs-center">
                <input :placeholder="measurements.weight" :class="{'invalid': errors.first('set3')}" class="round-input" name="set3" type="number" maxlength="5" v-model.number="set3">
                <p>Set 3</p>
              </v-flex>
              <v-flex v-show="exercises[activeExercise].sets > 3" class="text-xs-center">
                <input :placeholder="measurements.weight" :class="{'invalid': errors.first('set4')}" class="round-input" name="set4" type="number" maxlength="5" v-model.number="set4" v-show="exercises[activeExercise].sets > 3" :disabled="exercises[activeExercise].sets < 4">
                <p v-show="exercises[activeExercise].sets > 3">Set 4</p>
              </v-flex>
              <span class="error-msg" v-if="errors.items.length > 0">{{ errors.items[0].msg }}</span>
            </v-layout>
          </v-form>
        </v-container>

        <v-card-actions class="primary">
          <v-btn @click.native="startCountdown" :disabled="isCounting" flat dark>Start Rest</v-btn>
          <span class="subheading">&nbsp{{hours | two_digits}}:{{minutes | two_digits}}:{{seconds | two_digits}}</span>
          <v-spacer></v-spacer>
          <v-btn @click="addLog(next = true)" :loading="loadingBtn" flat dark>next</v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
    <v-dialog
      v-model="warning"
      full-width
      persistent
    >
      <v-card >
        <v-card-title style="justify-content: center;">Leaving? Incomplete workouts will not be saved!</v-card-title>
        <v-card-actions>
          <v-btn @click.native="warning = !warning" color="warning
          " flat >cancel</v-btn>
          <v-btn @click.native="cancelWorkout" color="warning" flat >Yes, leave</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="timerDiag"
      persistent
      max-width="200"
    >
      <v-card class="text-xs-center" v-if="activeData">
        <v-card-title style="justify-content: center;" class="headline grey--text" color="amber accent-4">
          <v-progress-circular color="amber accent-4" :rotate="-90" :size="150" :width="15" :value="timePercentage"></v-progress-circular>
          <div style="position: absolute;">{{hours | two_digits}}:{{minutes | two_digits}}:{{seconds | two_digits}}</div>
          </v-card-title>
        <v-card-actions class="no-padding">
          <v-btn @click.native="stopCountdown" color="amber accent-4" block depressed dark>stop</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="infoDialog"
      max-width="290"
    >
      <v-card v-if="activeInfoData">
         <v-card-media
          v-if="activeInfoData.exerciseData.video"
        >
        <div v-html="activeInfoData.exerciseData.video"></div>
        </v-card-media>

         <v-card-title v-if="activeInfoData" primary-title>
          <div>
            <h3 class="headline mb-0">{{activeInfoData.exerciseData.name}}</h3>
            <div class="grey--text">Type: {{activeInfoData.exerciseData.type}}</div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat="flat"
            @click="infoDialog = false"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
import amendReps from '@/utils/amendReps'

export default {
  name: 'WorkoutsShow',
  props: {
    selectedDate: {
      type: Number,
      required: true
    },
    workoutId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tll: [],
      set1: null,
      set2: null,
      set3: null,
      set4: null,
      timerDiag: false,
      infoDialog: false,
      sheet: false,
      warning: false,
      lastLogDialog: false,
      sheetExtended: false,
      workout: this.$route.params.workout,
      exercises: [],
      movements: [],
      workoutLogs: null,
      workoutLog: [
      ],
      loading: true,
      loadingBtn: false,
      LoadingDialog: false,
      activeExercise: null,
      activeInfo: null,
      interval: '',
      isCounting: false,
      measurements: JSON.parse(localStorage.getItem('measureSystem')),
      weightHint: JSON.parse(localStorage.getItem('weightHint'))
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    activeData () {
      return this.exercises[this.activeExercise]
    },
    activeInfoData () {
      return this.movements[this.activeInfo]
    },
    fabIcon () {
      return this.sheetExtended ? 'keyboard_arrow_down' : 'keyboard_arrow_up'
    },
    workoutStart () {
      // today / selected date
      let dateContext = moment.unix(this.selectedDate)

      if (this.userProfile.fresh) {
        return moment.unix(this.userProfile.commenced_at)
      }

      if (this.workout) {
        return this.workout.start ? moment.unix(this.workout.start) : dateContext
      }

      return dateContext
    },
    timePercentage () {
      var start = this.exercises[this.activeExercise].rest
      var current = this.exercises[this.activeExercise].restContext
      return Math.floor((current / start) * 100)
    },
    duration () {
      return this.exercises[this.activeExercise].restContext
    },
    seconds () {
      if (this.duration) {
        return +this.duration % 60
      } else {
        return '00'
      }
    },
    minutes () {
      if (this.duration) {
        return parseInt(this.duration / 60, 10) % 60
      } else {
        return '00'
      }
    },
    hours () {
      if (this.duration) {
        return parseInt(this.duration / 60 / 60) % 24
      } else {
        return '00'
      }
    },
    sessionTLL () {
      if (this.tll.length > 0) {
        return this.tll.reduce((total, amount) => total + amount)
      }
    }
  },
  watch: {
    sheet () {
      if (!this.sheet && this.activeData) {
        this.addLog(false)
      }
    }
  },
  methods: {
    getExercises () {
      const self = this
      self.loading = true
      db.collection('workout_exercises').where('workout_id', '==', self.$route.params.workoutId).orderBy('order')
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const newExercise = doc.data()
            self.$set(newExercise, 'restContext', doc.data().rest)
            if (newExercise.exercise_id) {
              newExercise.exercise_id.get()
                .then(snap => {
                  if (snap.exists) {
                    self.$set(newExercise, 'exercise_id', snap.id)
                    self.$set(newExercise, 'exerciseData', snap.data())
                    if ((newExercise.regression && self.userProfile.commenced_at) || (newExercise.progression && self.userProfile.commenced_at)) {
                      amendReps(newExercise, self.workoutStart, self.dateContext, self.currentUser.fresh).then((response) => {
                        if (!(response.deleted_at)) {
                          self.exercises.push(response)
                        }
                      })
                    } else {
                      if (!(newExercise.deleted_at)) {
                        self.exercises.push(newExercise)
                      }
                    }
                  } else {
                    var emptyExercise = {
                      'name': 'Unknown Exercise',
                      'type': 'none'
                    }
                    self.$set(newExercise, 'exercise_id', snap.id)
                    self.$set(newExercise, 'exerciseData', emptyExercise)
                    if (!(newExercise.deleted_at)) {
                      self.exercises.push(newExercise)
                    }
                  }
                }).catch(function (error) {
                  console.log('Error getting workouts: ', error)
                })
            }
          })
          self.loading = false
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    getMovements () {
      const self = this
      self.loading = true
      db.collection('workout_movements').where('workout_id', '==', self.$route.params.workoutId).orderBy('order')
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const newExercise = doc.data()
            if (newExercise.exercise_id) {
              newExercise.exercise_id.get()
                .then(snap => {
                  self.$set(newExercise, 'exercise_id', snap.id)
                  self.$set(newExercise, 'exerciseData', snap.data())
                  if (!(newExercise.deleted_at)) {
                    self.movements.push(newExercise)
                  }
                }).catch(function (error) {
                  console.log('Error getting workouts: ', error)
                })
            }
          })
          self.loading = false
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    getWorkoutLogs () {
      var self = this
      db.collection('workout_logs').where('user_id', '==', self.currentUser).where('workout_id', '==', self.$route.params.workoutId).orderBy('created_at', 'desc').limit(1)
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var newLog = doc.data()
            self.workoutLogs = Object.assign({}, newLog)
          })
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    addTll (filtered) {
      return new Promise(resolve => {
        var self = this
        var nums = [ this.set1, this.set2, this.set3, this.set4 ]
        var reps = this.activeData.reps
        var addNum = function (element, index, array) {
          return element * reps
        }
        const result = nums.map(addNum)
        const sum = result.reduce((total, amount) => total + amount)
        if (filtered) {
          var tllLog = this.tll.filter(function (log) {
            return log.exercise_id === self.activeData.exercise_id
          })
          tllLog.forEach(log => {
            this.$set(log, 'workout_id', this.activeData.exercise_id)
            this.$set(log, 'value', sum)
          })
          resolve('updated')
        } else {
          const tll = {}
          this.$set(tll, 'workout_id', this.activeData.exercise_id)
          this.$set(tll, 'value', sum)
          this.tll.push(tll)
          resolve('addded')
        }
      })
    },
    addLog (next) {
      var self = this
      this.LoadingDialog = true
      // see if already logged
      var filtered = []
      if (this.workoutLog.length > 0) {
        filtered = this.workoutLog.filter(function (log) {
          return log.exercise_id === self.activeData.exercise_id
        })
      }
      // if alrady logged - edit / else - add new
      if (filtered.length > 0) {
        filtered.forEach(log => {
          this.$set(log, 'set1', this.set1)
          this.$set(log, 'set2', this.set2)
          this.$set(log, 'set3', this.set3)
          this.$set(log, 'set4', this.set4)
        })
        this.addTll(filtered).then((response) => {
          this.$set(this.exercises[this.activeExercise], 'complete', true)
          this.sheetExtended = false
          this.set1 = null
          this.set2 = null
          this.set3 = null
          this.set4 = null
          if (next) {
            if (this.activeExercise < (this.exercises.length - 1)) {
              this.activeExercise = this.activeExercise + 1
              var filtered = []
              if (this.workoutLog.length > 0) {
                filtered = this.workoutLog.filter(function (log) {
                  return log.exercise_id === self.activeData.exercise_id
                })
              }
              if (filtered.length > 0) {
                this.set1 = filtered[0].set1
                this.set2 = filtered[0].set2
                this.set3 = filtered[0].set3
                this.set4 = filtered[0].set4
              }
              this.$nextTick(function () {
                this.activeRest = this.activeData.rest
              })
            } else {
              this.activeExercise = null
              this.sheet = false
            }
          } else {
            this.activeExercise = null
            this.sheet = false
          }
          this.LoadingDialog = false
        })
      } else {
        this.workoutLog.push({
          id: this.activeData.order,
          workout_id: this.activeData.workout_id,
          exercise_id: this.activeData.exercise_id,
          exercise_name: this.activeData.exerciseData.name,
          set1: this.set1,
          set2: this.set2,
          set3: this.set3,
          set4: this.set4
        })
        this.addTll().then((response) => {
          this.$set(this.exercises[this.activeExercise], 'complete', true)
          this.sheetExtended = false
          this.set1 = null
          this.set2 = null
          this.set3 = null
          this.set4 = null
          if (next) {
            if (this.activeExercise < (this.exercises.length - 1)) {
              this.activeExercise = this.activeExercise + 1
              var filtered = []
              if (this.workoutLog.length > 0) {
                filtered = this.workoutLog.filter(function (log) {
                  return log.exercise_id === self.activeData.exercise_id
                })
              }
              if (filtered.length > 0) {
                this.set1 = filtered[0].set1
                this.set2 = filtered[0].set2
                this.set3 = filtered[0].set3
                this.set4 = filtered[0].set4
              }
              this.$nextTick(function () {
                this.activeRest = this.activeData.rest
              })
            } else {
              this.activeExercise = null
              this.sheet = false
            }
          } else {
            this.activeExercise = null
            this.sheet = false
          }
          this.LoadingDialog = false
        })
      }
    },
    submitWorkout () {
      function lbsToKgs (lbs) {
        var kgs = (lbs / 2.205)
        return +kgs
      }
      var self = this
      self.loadingBtn = true
      var date = self.selectedDate
      var workoutLog = _.sortBy(self.workoutLog, function (el) {
        return el.id
      })
      var tll = self.tll.reduce((prev, cur) => prev + cur.value, 0)
      var workoutLogRef = db.collection('workout_logs').doc(self.currentUser + '-' + date)
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      if (localMeasureSystem.weight === 'lbs') {
        workoutLog.forEach(log => {
          log.set1 = lbsToKgs(log.set1)
          log.set2 = lbsToKgs(log.set2)
          log.set3 = lbsToKgs(log.set3)
          log.set4 = lbsToKgs(log.set4)
        })
        tll = lbsToKgs(tll)
      }
      for (var i = 0; i < workoutLog.length; i++) {
        var field = 'wo' + i
        workoutLogRef.set({
          [field]: workoutLog[i],
          sessionTll: tll,
          created_at: date,
          user_id: self.currentUser,
          workout_id: self.$route.params.workoutId
        }, {merge: true})
          .then(function () {
          })
          .catch(function (error) {
            this.loadingBtn = false
            this.sheet = false
            this.activeExercise = null
            console.error('Error', error)
          })
      }
      if (self.workout.duration && (!self.workout.start || !self.workout.end)) {
        self.setEndDate()
      } else {
        this.loadingBtn = false
        this.sheet = false
        this.activeExercise = null
        this.workoutLog = []
        this.dialog = false
        this.$router.push({ name: 'Workouts' })
      }
    },
    setEndDate () {
      var self = this
      var currentDay = moment().startOf('day')
      var endDay = moment(currentDay).add(this.workout.duration, 'w')
      // Update Start and End day
      var workoutRef = db.collection('user_workouts').doc(self.$route.params.workoutId)
      workoutRef.set({
        start: moment(currentDay).unix(),
        end: moment(endDay).unix()
      }, { merge: true })
        .then(function () {
          self.loadingBtn = false
          self.sheet = false
          self.activeExercise = null
          self.workoutLog = []
          self.dialog = false
          self.$router.push({ name: 'Workouts' })
        })
        .catch(function (error) {
          self.loadingSave = false
          console.error('Error', error)
        })
    },
    openSheet (index) {
      var self = this
      this.sheet = true
      this.activeExercise = index
      var filtered = this.workoutLog.filter(function (log) {
        return log.id === self.activeExercise
      })
      if (filtered.length > 0) {
        this.set1 = filtered[0].set1
        this.set2 = filtered[0].set2
        this.set3 = filtered[0].set3
        this.set4 = filtered[0].set4
      }
      this.$nextTick(function () {
        this.activeRest = this.activeData.rest
      })
    },
    radioIcon (exercise) {
      if (exercise.active) {
        return 'radio_button_checked'
      } else {
        return 'radio_button_unchecked'
      }
    },
    startCountdown () {
      var self = this
      self.isCounting = true
      self.timerDiag = true
      self.interval = setInterval(function () {
        if (self.exercises[self.activeExercise].restContext > 0) {
          self.exercises[self.activeExercise].restContext = self.exercises[self.activeExercise].restContext - 1
        } else {
          self.stopCountdown()
        }
      }, 1000)
    },
    stopCountdown () {
      clearInterval(this.interval)
      // if (navigator.vibrate) {
      //   navigator.vibrate(10000)
      // }
      this.timerDiag = false
      this.isCounting = false
      this.exercises[this.activeExercise].restContext = this.exercises[this.activeExercise].rest
    },
    openInfoDialog (index) {
      this.activeInfo = index
      this.infoDialog = true
    },
    cancelWorkout () {
      this.workoutLog = []
      this.$router.go(-1)
    },
    closeHint () {
      this.weightHint = false
      localStorage.setItem('weightHint', JSON.stringify(false))
    },
    gotTo () {
      localStorage.setItem('weightHint', JSON.stringify(false))
      this.$router.push({name: 'Member Settings'})
    }
  },
  mounted () {
    this.getExercises()
    this.getMovements()
    this.getWorkoutLogs()
  },
  // called when the route that renders this component is about to
  // be navigated away from.
  // has access to `this` component instance.
  beforeRouteLeave (to, from, next) {
    if (this.workoutLog.length > 0) {
      this.warning = true
    } else {
      next()
    }
  }
}
</script>
<style  lang="scss" scoped>
  #workout-list {
    padding-left: 0px;
    li {
      align-items: center;
      color: inherit;
      display: flex;
      font-size: 16px;
      font-weight: 400;
      height: 56px;
      margin: 0;
      padding: 0 16px;
      position: relative;
      text-decoration: none;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

      &:nth-last-of-type(odd) {
        background-color: #fff;
      }
      &:first-of-type .list-timeline:after {
        margin-top: 28px;
      }
      &:last-of-type .list-timeline:after {
        margin-bottom: 28px;
      }
      &:hover {
        background: rgba(0,0,0,0.04)
      }

      .list-content {
        text-align: left;
        flex: 1 1 auto;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
      }
      .list-title {
        height: 24px;
        line-height: 24px;
        position: relative;
        text-align: left;
        text-transform: uppercase;
      }
      .list-title span.sub-info {
        font-size: 12px;
      }
      .list-timeline {
        display: flex;
        justify-content: flex-start;
        min-width: 48px;
      }
      .list-timeline:after {
        content: '';
        position: absolute;
        width: 1px;
        background-color: #3bbb51;
        top: 0;
        bottom: 0;
        left: 21px;
        margin-left: 0.5px;
        z-index: 0;
      }
      .list-timeline .v-icon {
        z-index: 1;
      }
    }
  }
  .v-card .container {
    padding: 0px!important;
  }
  #input-layout {
    height: 136px!important;
    position: relative;
  }
  .round-input {
    width: 50px;
    height: 50px;
    margin-bottom: 8px;
    border: 4px solid rgba(255, 255, 255, .8);
    border-radius: 50%;
    text-align: center;
  }
  .round-input:focus {
    width: 75px;
    height: 75px;
    font-size: 20px;
    font-weight: 600;
    outline: none!important;
  }
  .round-input.invalid {
    border-color: #FFAB00;
  }
  .error-msg {
    position: absolute;
    color: #FFAB00;
    bottom: 8px;
    left: 24px;
  }
  .video-container {
    padding: 0 16px;
  }
  .video-container iframe {
      width: 100%;
      height: auto;
    }
    .headline .sub-info {
      font-size: 16px;
    }
    .table {
    width: 100%;
    display: table;
    border-collapse: collapse;
    border-spacing: 0;
  }
  .table-toolbar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 16px;
  }
  .table-toolbar .title {
    line-height: 36px!important;
  }
  .table-toolbar .v-icon {
    line-height: inherit!important;
  }
  .table-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }
  .table-header div {
    color: rgba(0,0,0,0.6);
  }
  .table-body:nth-last-of-type(even) {
    background-color: rgba(242,242,242,0.5);
  }
  .table-body > div > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px 0px;
    border-bottom: 1px solid rgba(0,0,0,0.12);
  }
  .v-dialog__container {
    width: 100%;
    margin-bottom: 8px;
  }
  ::placeholder {
    color: rgba(255,255,255,0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/members/workoutsShow.vue